import { PERMISSIONS } from "shared";
import { immer } from "zustand/middleware/immer";

interface PermissionsState {
  permissions: Array<any>;
  resourceType: string;
  customers: Array<any>;
}

interface PermissionsAction {
  setPermissions: (
    resourceType: string,
    permissions: Array<any>,
    customers?: Array<any>
  ) => void;
  hasPermissions: (
    permissions: Array<string>,
    operator?: "AND" | "OR"
  ) => boolean;
  isModulePermitted: (
    module: "SD" | "CC" | "BL" | "RPT" | "CUSTOMER"
  ) => boolean;
  doesHavePermissionToCustomer: (customerId: string) => boolean;
  doesHaveFullAccessToCustomer: (customerId: string) => boolean;
  isSuperAdmin: () => boolean;
  isAdmin: () => boolean;
  isNormal: () => boolean;
  isFinanceAdmin: () => boolean;
}

export interface PermissionsInterface
  extends PermissionsState,
    PermissionsAction {}

export const PermissionsSlice = immer<PermissionsState & PermissionsAction>(
  (set, get) => ({
    permissions: [],
    resourceType: "",
    customers: [],
    setPermissions(resourceType, permissions, customers = []) {
      set((state) => {
        state.permissions = permissions;
        state.resourceType = resourceType;
        state.customers = customers;
      });
    },
    hasPermissions(permissions, operator = "AND") {
      const permissionList = get().permissions;
      let result;
      if (operator === "AND") {
        result = permissions.every((permission) =>
          permissionList.includes(permission)
        );
      } else {
        result = permissions.some((permission) =>
          permissionList.includes(permission)
        );
      }
      return result;
    },
    isModulePermitted(module) {
      const permissions = get().permissions;
      return permissions.some((permission) =>
        Object.values(PERMISSIONS[module]).includes(permission)
      );
    },
    doesHavePermissionToCustomer(customerId) {
      const permissions = get().permissions;
      const customers = get().customers;
      return (
        permissions.includes(PERMISSIONS.CUSTOMER.CUSTOMER_ALL_RW) ||
        (permissions.includes(PERMISSIONS.CUSTOMER.CUSTOMER_CUSTOM_RW) &&
          customers.findIndex(
            (customer) => customer.mapping_id === customerId
          ) !== -1)
      );
    },
    doesHaveFullAccessToCustomer(customerId) {
      const permissions = get().permissions;
      const customer = get().customers.find(
        (customer) => customer.mapping_id === customerId
      );
      return (
        permissions.includes(PERMISSIONS.CUSTOMER.CUSTOMER_ALL_RW) ||
        Boolean(customer && customer?.permission === "rw")
      );
    },
    isSuperAdmin() {
      return get().resourceType === "b110abc3-0709-491f-ac04-86eb25159386";
    },
    isAdmin() {
      return get().resourceType === "9d6afd0e-b353-438d-a34d-1bb1cc5bbf03";
    },
    isNormal() {
      return get().resourceType === "ff1088b8-d50b-4d89-a033-94bf3b9f450d";
    },
    isFinanceAdmin() {
      return get().resourceType === "1fd002ed-1704-45f1-98d2-f97cc8dc2050";
    },
  })
);
